import { RejectionReason } from "@/types/fse";

const REJECTION_LABELS: Record<RejectionReason, string> = {
  ENCRYPTED_PDF: "Encrypted PDF",
  UNSUPPORTED_FILE: "Unsupported file",
  FILE_CONTENT_MISMATCH: "Contents don't match the file extension",
};

export const getRejectionLabel = (reason: RejectionReason): string =>
  REJECTION_LABELS[reason] ?? `Unknown rejection (${reason})`;
